import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[BaseOnlydate]',
  standalone: false
})
export class OnlydateDirective {

  private regex: RegExp = new RegExp(/^[0-9]{0,2}\/?[0-9]{0,2}\/?[0-9]{0,4}$/);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return; // Permitir teclas especiales
    }
    let current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
